






import { defineComponent } from '@vue/composition-api';

import PanelWithSessionEditor from '@/components/Live/PanelWithSessionEditor.vue';

const Edit = defineComponent({
  components: {
    PanelWithSessionEditor,
  },
  // setup() {},
});

export default Edit;
